import { render, staticRenderFns } from "./LockedUser.vue?vue&type=template&id=13960094&scoped=true&"
import script from "./LockedUser.vue?vue&type=script&lang=ts&"
export * from "./LockedUser.vue?vue&type=script&lang=ts&"
import style0 from "./LockedUser.vue?vue&type=style&index=0&id=13960094&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13960094",
  null
  
)

export default component.exports